import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  TimePicker
} from "antd";
import moment from "moment";
import { Component } from "react";
import "../styles/general.css";

import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { UPDATE } from "../constants/request-type";
import { hub as hubRoute, update_hub } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Hub_new extends Component {
  state = {
    visible: false,
    address: this.props.row?.address,
    line: this.props.row?.line || "",
    position: this.props.row?.position || {
      lat: 0,
      lng: 0
    },
    name: this.props.row?.name || "",
    city: this.props.row?.city || "",
    postalCode: this.props.row?.postalCode || "",
    timezone: this.props.row?.timezone || "",
    metropolitan_area: this.props.row?.metropolitan_area || "",
    days: this.props.row?.days || [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    inactiveDates: this.props.row?.inactiveDates || [],
    opening: this.props.row?.opening || "09:00",
    closing: this.props.row?.closing || "21:00",
    instruction: this.props.row?.instruction,
    phone: this.props.row?.phone || "",
    list: [],
    locked: false,
    load: false
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.position !== this.state.position) {
      logger.log("🔄 Position state changed in EDIT form:", {
        previous: prevState.position,
        current: this.state.position
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  calculateHubStatus = (days, inactiveDates) => {
    if (!days || days.length === 0) return false;

    const today = new Date().toLocaleDateString("en-US", { weekday: "long" });
    const todayDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format
    const currentTime = new Date().toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit"
    });

    // Check if today is in active days
    const isActiveDay = days.includes(today);

    // Check if today is not in inactive date ranges
    const isNotInactiveDate = !inactiveDates.some((inactiveDate) => {
      const { dateRange, timeRange } = inactiveDate;
      const { startDate, endDate } = dateRange;
      const { startTime, endTime } = timeRange;

      // Check if today is within the date range
      const isInDateRange = todayDate >= startDate && todayDate <= endDate;

      if (isInDateRange) {
        // Check if current time is within the time range
        const isInTimeRange =
          currentTime >= startTime && currentTime <= endTime;
        return isInTimeRange;
      }

      return false;
    });

    return isActiveDay && isNotInactiveDate;
  };

  async handleConvert(text) {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          text
        )}&key=${process.env.REACT_APP_API_KEY_MAP}`
      );
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        const addressComponents = data.results[0].address_components;

        // Extract city name, postal code, timezone, and suggested hub name
        let city = "";
        let postalCode = "";
        let timezone = "";
        let suggestedHubName = "";

        addressComponents.forEach((component) => {
          if (
            component.types.includes("locality") ||
            component.types.includes("administrative_area_level_2")
          ) {
            city = component.long_name;
          }
          if (component.types.includes("postal_code")) {
            postalCode = component.long_name;
          }
        });

        // City will be used as the hub name directly

        // Get timezone using coordinates
        try {
          const timezoneResponse = await fetch(
            `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${Math.floor(Date.now() / 1000)}&key=${process.env.REACT_APP_API_KEY_MAP}`
          );
          const timezoneData = await timezoneResponse.json();

          if (timezoneData.status === "OK") {
            timezone = timezoneData.timeZoneId;
          }
        } catch (timezoneError) {
          logger.warn("⚠️ Timezone detection failed:", timezoneError);
        }

        logger.log(
          "📍 Address converted in EDIT form - City:",
          city,
          "Setting as suggested hub name"
        );
        logger.log("📍 New coordinates will be:", { lat, lng });

        // Extract metropolitan area from address components
        let metropolitan_area = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("administrative_area_level_2")) {
            metropolitan_area = component.long_name;
          }
        });

        this.setState({
          address: text,
          position: { lat, lng },
          name: city, // Set city as suggested hub name
          city: city,
          postalCode: postalCode,
          timezone: timezone,
          metropolitan_area: metropolitan_area
        });

        logger.log("📍 State updated in EDIT form. New position:", {
          lat,
          lng
        });
        logger.log("✅ Address converted:", {
          street: text,
          lat,
          lng,
          city,
          postalCode,
          timezone,
          suggestedHubName
        });
      } else {
        this.setState({
          address: text,
          position: { lat: 0, lng: 0 },
          city: "",
          postalCode: "",
          timezone: ""
        });
        logger.log("❌ Geocoding failed");
      }
    } catch (error) {
      logger.error("❌ Geocoding error:", error);
      this.setState({
        address: text,
        position: { lat: 0, lng: 0 },
        city: "",
        postalCode: "",
        timezone: ""
      });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const {
      address,
      line,
      position,
      name,
      city,
      postalCode,
      timezone,
      metropolitan_area,
      days,
      inactiveDates,
      opening,
      closing,
      instruction,
      phone
    } = this.state;

    // Convert position to GeoJSON format for MongoDB
    const geoJSONPosition =
      position && position.lat && position.lng
        ? {
            type: "Point",
            coordinates: [position.lng, position.lat] // MongoDB expects [lng, lat]
          }
        : undefined;

    const data = {
      name: name?.toLowerCase(),
      address: address?.toLowerCase(),
      line: line?.toLowerCase(),
      ...(geoJSONPosition && { position: geoJSONPosition }),
      city: city?.toLowerCase(),
      postalCode: postalCode,
      timezone: timezone,
      metropolitan_area: metropolitan_area,
      days: days,
      inactiveDates: inactiveDates,
      opening,
      closing,
      instruction: instruction?.toLowerCase(),
      phone: phone,
      status: this.calculateHubStatus(days, inactiveDates)
    };

    logger.log("💾 EDIT form submitting data:", data);
    logger.log("💾 EDIT form position being sent:", geoJSONPosition);
    logger.log("💾 EDIT form original position:", position);
    logger.log(
      "💾 EDIT form position.lat:",
      position.lat,
      "position.lng:",
      position.lng
    );

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: hubRoute + "/" + update_hub + "/" + this.props.row?._id,
      data: data,
      token: token
    };

    if (data.name.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    if (!data.address || data.address.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Veuillez fournir une adresse valide"
      );
    }

    if (!data.city || data.city.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Impossible de détecter la ville. Veuillez sélectionner une adresse valide"
      );
    }

    if (!data.postalCode || data.postalCode.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Impossible de détecter le code postal. Veuillez sélectionner une adresse valide"
      );
    }

    if (!data.phone || data.phone.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Le numéro de téléphone est requis"
      );
    }

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {
      address,
      line,
      position,
      name,
      city,
      postalCode,
      timezone,
      days,
      inactiveDates,
      opening,
      closing,
      instruction,
      phone,
      load
    } = this.state;

    logger.log("🎨 EDIT form rendering with position:", position);
    logger.log(
      "🎨 EDIT form position.lat:",
      position.lat,
      "type:",
      typeof position.lat
    );
    logger.log(
      "🎨 EDIT form position.lng:",
      position.lng,
      "type:",
      typeof position.lng
    );

    return (
      <>
        <Button type="danger" onClick={this.showDrawer}>
          Modifier
        </Button>
        <Drawer
          title="Modifier un hub"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label={
                    <span>
                      Adresse <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      name: "address"
                    }
                  ]}
                >
                  <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_API_KEY_MAP}
                    selectProps={{
                      placeholder: "Sélectionner une adresse",
                      value: address
                        ? { label: address, value: address }
                        : null,
                      onChange: (selectedPlace) => {
                        if (selectedPlace) {
                          logger.log(
                            "🎯 Place selected in EDIT form:",
                            selectedPlace.label
                          );
                          logger.log(
                            "🎯 Current state before conversion:",
                            this.state.position
                          );
                          this.handleConvert(selectedPlace.label);
                        }
                      },
                      onInputChange: (inputValue) => {
                        logger.log(
                          "🔤 Input changed in EDIT form:",
                          inputValue
                        );
                        if (inputValue && inputValue.length > 5) {
                          // Auto-geocode when user types enough characters
                          logger.log(
                            "🔤 Triggering geocoding for input:",
                            inputValue
                          );
                          this.handleConvert(inputValue);
                        }
                      },
                      onFocus: () => {
                        logger.log(
                          "🎯 Google Places autocomplete focused in EDIT form"
                        );
                      },
                      onBlur: () => {
                        logger.log(
                          "🎯 Google Places autocomplete blurred in EDIT form"
                        );
                      },
                      styles: {
                        container: (provided) => ({
                          ...provided,
                          width: "100%"
                        }),
                        control: (provided, state) => ({
                          ...provided,
                          padding: "4px",
                          fontSize: "16px",
                          border: `2px solid ${state.isFocused ? "#ff114d" : "#ddd"}`,
                          borderRadius: "5px",
                          outline: "none",
                          transition: "border-color 0.3s",
                          boxSizing: "border-box",
                          boxShadow: "none",
                          "&:hover": {
                            borderColor: state.isFocused ? "#ff114d" : "#ddd"
                          }
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#999"
                        })
                      }
                    }}
                    autocompletionRequest={{
                      componentRestrictions: { country: "ca" },
                      language: "fr"
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label={
                    <span>
                      Nom du hub <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Le nom du hub est requis"
                    }
                  ]}
                >
                  <Input
                    name="name"
                    value={name}
                    onChange={this.handleChange}
                    placeholder="Nom du hub (ex: Hub Montréal, Hub Toronto...)"
                    style={{
                      backgroundColor: name ? "#f0f8ff" : "#fff",
                      border: name ? "2px solid #1890ff" : "1px solid #d9d9d9"
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Ligne d'adresse 2"
                  rules={[
                    {
                      required: false,
                      message: "La ligne d'adresse 2 est optionnelle"
                    }
                  ]}
                >
                  <Input
                    name="line"
                    placeholder="Appartement, Suite, Unité, etc."
                    onChange={this.handleChange}
                    value={line}
                  />
                </Form.Item>
              </Col>

              {/* Coordinate Display Fields */}
              <Col span={12}>
                <Form.Item label="Latitude (Auto-filled)">
                  <Input
                    value={position.lat ? position.lat.toString() : ""}
                    disabled
                    style={{
                      backgroundColor: "#f5f5f5",
                      color: "#666"
                    }}
                    placeholder="Will be filled automatically when address is selected"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Longitude (Auto-filled)">
                  <Input
                    value={position.lng ? position.lng.toString() : ""}
                    disabled
                    style={{
                      backgroundColor: "#f5f5f5",
                      color: "#666"
                    }}
                    placeholder="Will be filled automatically when address is selected"
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={
                    <span>
                      Ville <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      name: "city"
                    }
                  ]}
                >
                  <Input
                    name="city"
                    value={city}
                    onChange={this.handleChange}
                    placeholder="Ville"
                    style={{
                      backgroundColor: city ? "#f0f8ff" : "#fff",
                      border: city ? "2px solid #1890ff" : "1px solid #d9d9d9"
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <span>
                      Code postal <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      name: "postalCode"
                    }
                  ]}
                >
                  <Input
                    name="postalCode"
                    value={postalCode}
                    onChange={this.handleChange}
                    placeholder="Code postal"
                    style={{
                      backgroundColor: postalCode ? "#f0f8ff" : "#fff",
                      border: postalCode
                        ? "2px solid #1890ff"
                        : "1px solid #d9d9d9"
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label={
                    <span>
                      Numéro de téléphone{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Le numéro de téléphone est requis"
                    }
                  ]}
                >
                  <Input
                    name="phone"
                    value={phone}
                    onChange={this.handleChange}
                    placeholder="Numéro de téléphone du hub (ex: +1 514-123-4567)"
                    style={{
                      backgroundColor: phone ? "#f0f8ff" : "#fff",
                      border: phone ? "2px solid #1890ff" : "1px solid #d9d9d9"
                    }}
                  />
                </Form.Item>
              </Col>
              {timezone && (
                <Col span={24}>
                  <Form.Item label="Fuseau horaire détecté">
                    <Input
                      value={timezone}
                      disabled
                      style={{ backgroundColor: "#f5f5f5" }}
                      placeholder="Fuseau horaire détecté automatiquement"
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={24}>
                <Form.Item
                  label={
                    <span>
                      Jours d'ouverture <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      name: "days"
                    }
                  ]}
                >
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder="Sélectionner les jours d'ouverture"
                    value={days}
                    onChange={(selectedDays) => {
                      this.setState({ days: selectedDays });
                    }}
                  >
                    <Option value="Monday">Lundi</Option>
                    <Option value="Tuesday">Mardi</Option>
                    <Option value="Wednesday">Mercredi</Option>
                    <Option value="Thursday">Jeudi</Option>
                    <Option value="Friday">Vendredi</Option>
                    <Option value="Saturday">Samedi</Option>
                    <Option value="Sunday">Dimanche</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Périodes d'inactivité (optionnel)">
                  <div>
                    {inactiveDates.map((inactiveDate, index) => (
                      <div
                        key={index}
                        style={{
                          marginBottom: 16,
                          padding: 16,
                          border: "1px solid #d9d9d9",
                          borderRadius: 6
                        }}
                      >
                        <Row gutter={[8, 8]}>
                          <Col span={12}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: 4,
                                fontWeight: "bold"
                              }}
                            >
                              Date de début:
                            </label>
                            <DatePicker
                              value={
                                inactiveDate.dateRange?.startDate
                                  ? moment(inactiveDate.dateRange.startDate)
                                  : null
                              }
                              onChange={(date) => {
                                const newInactiveDates = [...inactiveDates];
                                if (!newInactiveDates[index].dateRange)
                                  newInactiveDates[index].dateRange = {};
                                newInactiveDates[index].dateRange.startDate =
                                  date ? date.format("YYYY-MM-DD") : "";
                                this.setState({
                                  inactiveDates: newInactiveDates
                                });
                              }}
                              style={{ width: "100%" }}
                              placeholder="Date de début"
                            />
                          </Col>
                          <Col span={12}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: 4,
                                fontWeight: "bold"
                              }}
                            >
                              Date de fin:
                            </label>
                            <DatePicker
                              value={
                                inactiveDate.dateRange?.endDate
                                  ? moment(inactiveDate.dateRange.endDate)
                                  : null
                              }
                              onChange={(date) => {
                                const newInactiveDates = [...inactiveDates];
                                if (!newInactiveDates[index].dateRange)
                                  newInactiveDates[index].dateRange = {};
                                newInactiveDates[index].dateRange.endDate = date
                                  ? date.format("YYYY-MM-DD")
                                  : "";
                                this.setState({
                                  inactiveDates: newInactiveDates
                                });
                              }}
                              style={{ width: "100%" }}
                              placeholder="Date de fin"
                            />
                          </Col>
                          <Col span={12}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: 4,
                                fontWeight: "bold"
                              }}
                            >
                              Heure de début:
                            </label>
                            <TimePicker
                              value={
                                inactiveDate.timeRange?.startTime
                                  ? moment(
                                      inactiveDate.timeRange.startTime,
                                      "HH:mm"
                                    )
                                  : null
                              }
                              onChange={(time) => {
                                const newInactiveDates = [...inactiveDates];
                                if (!newInactiveDates[index].timeRange)
                                  newInactiveDates[index].timeRange = {};
                                newInactiveDates[index].timeRange.startTime =
                                  time ? time.format("HH:mm") : "00:00";
                                this.setState({
                                  inactiveDates: newInactiveDates
                                });
                              }}
                              format="HH:mm"
                              style={{ width: "100%" }}
                              placeholder="Heure de début"
                            />
                          </Col>
                          <Col span={12}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: 4,
                                fontWeight: "bold"
                              }}
                            >
                              Heure de fin:
                            </label>
                            <TimePicker
                              value={
                                inactiveDate.timeRange?.endTime
                                  ? moment(
                                      inactiveDate.timeRange.endTime,
                                      "HH:mm"
                                    )
                                  : null
                              }
                              onChange={(time) => {
                                const newInactiveDates = [...inactiveDates];
                                if (!newInactiveDates[index].timeRange)
                                  newInactiveDates[index].timeRange = {};
                                newInactiveDates[index].timeRange.endTime = time
                                  ? time.format("HH:mm")
                                  : "23:59";
                                this.setState({
                                  inactiveDates: newInactiveDates
                                });
                              }}
                              format="HH:mm"
                              style={{ width: "100%" }}
                              placeholder="Heure de fin"
                            />
                          </Col>
                          <Col span={20}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: 4,
                                fontWeight: "bold"
                              }}
                            >
                              Raison:
                            </label>
                            <Input
                              placeholder="Raison (ex: Fête nationale, Incident, Maintenance...)"
                              value={inactiveDate.reason}
                              onChange={(e) => {
                                const newInactiveDates = [...inactiveDates];
                                newInactiveDates[index].reason = e.target.value;
                                this.setState({
                                  inactiveDates: newInactiveDates
                                });
                              }}
                            />
                          </Col>
                          <Col span={4}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: 4,
                                fontWeight: "bold"
                              }}
                            >
                              &nbsp;
                            </label>
                            <Button
                              type="link"
                              danger
                              onClick={() => {
                                const newInactiveDates = inactiveDates.filter(
                                  (_, i) => i !== index
                                );
                                this.setState({
                                  inactiveDates: newInactiveDates
                                });
                              }}
                              style={{ width: "100%" }}
                            >
                              Supprimer
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    ))}
                    <Button
                      type="dashed"
                      onClick={() => {
                        this.setState({
                          inactiveDates: [
                            ...inactiveDates,
                            {
                              dateRange: { startDate: "", endDate: "" },
                              timeRange: {
                                startTime: "00:00",
                                endTime: "23:59"
                              },
                              reason: ""
                            }
                          ]
                        });
                      }}
                      style={{ width: "100%" }}
                    >
                      + Ajouter une période d'inactivité
                    </Button>
                  </div>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <span>
                      Heure d'ouverture{timezone ? ` (${timezone})` : ""}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      name: "opening"
                    }
                  ]}
                >
                  <input
                    type="time"
                    style={{
                      width: "100%",
                      border: "1px solid #cecece",
                      height: 33
                    }}
                    name="opening"
                    placeholder="ouverture"
                    onChange={this.handleChange}
                    value={opening}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <span>
                      Heure de fermeture{timezone ? ` (${timezone})` : ""}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      name: "closing"
                    }
                  ]}
                >
                  <input
                    type="time"
                    style={{
                      width: "100%",
                      border: "1px solid #cecece",
                      height: 33
                    }}
                    name="closing"
                    placeholder="fermeture"
                    onChange={this.handleChange}
                    value={closing}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label={
                    <span>
                      Instructions <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Les instructions sont requises"
                    }
                  ]}
                >
                  <Input.TextArea
                    name="instruction"
                    rows={4}
                    placeholder="instruction"
                    onChange={this.handleChange}
                    value={instruction}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Hub_new;
